export const ROLES = ["SUPER_ADMIN", "ADMIN", "PROJECT_MANAGER", "TEAM_LEAD", "DEVELOPER", "TESTER", "VIEWER"];

export const ROLE_LABELS = {
  SUPER_ADMIN: "Super Admin",
  ADMIN: "Admin",
  PROJECT_MANAGER: "Project Manager",
  TEAM_LEAD: "Team Lead",
  DEVELOPER: "Developer",
  TESTER: "Tester",
  VIEWER: "Viewer",
};

export const TASK_STATUSES = ["NEW", "BACKLOG", "IN_PROGRESS", "IN_REVIEW", "COMPLETED", "REASSIGNED"];
export const TASK_STATUS_LABELS = {
  NEW: "New",
  BACKLOG: "Backlog",
  IN_PROGRESS: "In Progress",
  IN_REVIEW: "In Review",
  COMPLETED: "Completed",
  REASSIGNED: "Reassigned",
};

export const TASK_PRIORITIES = ["LOW", "MEDIUM", "HIGH", "URGENT"];

export const BUG_STATUSES = [
  "New",
  "Assigned",
  "Open",
  "Fixed",
  "Pending Retest / Ready for QA",
  "Retest",
  "Verified",
  "Closed",
  "Reopened",
  "Rejected / Invalid",
  "Duplicate",
  "Not a Defect",
  "Cannot Be Fixed / Won't Fix",
  "Need More Information",
];
export const LEGACY_BUG_STATUSES = ["OPEN", "IN_PROGRESS", "IN_REVIEW", "RESOLVED", "REOPENED", "CLOSED"];
export const ALL_BUG_STATUSES = [
  ...BUG_STATUSES,
  ...LEGACY_BUG_STATUSES.filter((s) => !BUG_STATUSES.includes(s)),
];

export const STATUS_TO_LEGACY = {
  "New": "OPEN",
  "Open": "OPEN",
  "Assigned": "IN_PROGRESS",
  "Fixed": "RESOLVED",
  "Pending Retest / Ready for QA": "IN_REVIEW",
  "Retest": "IN_PROGRESS",
  "Verified": "RESOLVED",
  "Closed": "CLOSED",
  "Reopened": "REOPENED",
  "Rejected / Invalid": "CLOSED",
  "Duplicate": "CLOSED",
  "Not a Defect": "CLOSED",
  "Cannot Be Fixed / Won't Fix": "CLOSED",
  "Need More Information": "IN_REVIEW",
};

export const BUG_SEVERITIES = ["LOW", "MEDIUM", "HIGH", "CRITICAL"];

export const THEMES = [
  { id: "light-ocean", name: "Ocean", swatch: "#2563eb" },
  { id: "light-earth", name: "Earth", swatch: "#166534" },
  { id: "light-peach", name: "Peach", swatch: "#e04a2b" },
  { id: "light-brutal", name: "Brutal", swatch: "#000000" },
];

export function statusBadgeClass(status) {
  const norm = (status || "").toString().trim().toUpperCase();
  switch (norm) {
    case "NEW":
      return "bg-blue-100 text-blue-800 border-blue-200";
    case "ASSIGNED":
      return "bg-indigo-100 text-indigo-800 border-indigo-200";
    case "OPEN":
      return "bg-amber-100 text-amber-800 border-amber-200";
    case "FIXED":
      return "bg-teal-100 text-teal-800 border-teal-200";
    case "PENDING RETEST / READY FOR QA":
      return "bg-orange-100 text-orange-800 border-orange-200";
    case "RETEST":
      return "bg-purple-100 text-purple-800 border-purple-200";
    case "VERIFIED":
      return "bg-emerald-100 text-emerald-800 border-emerald-200";
    case "CLOSED":
    case "COMPLETED":
    case "RESOLVED":
      return "bg-slate-200 text-slate-800 border-slate-300";
    case "REOPENED":
    case "REASSIGNED":
      return "bg-rose-100 text-rose-800 border-rose-200";
    case "REJECTED / INVALID":
    case "CANNOT BE FIXED / WON'T FIX":
      return "bg-red-100 text-red-800 border-red-200";
    case "DUPLICATE":
    case "NOT A DEFECT":
      return "bg-gray-100 text-gray-700 border-gray-200";
    case "NEED MORE INFORMATION":
      return "bg-yellow-100 text-yellow-800 border-yellow-200";
    case "IN_PROGRESS":
      return "bg-amber-100 text-amber-800 border-amber-200";
    case "IN_REVIEW":
      return "bg-sky-100 text-sky-800 border-sky-200";
    case "BACKLOG":
      return "bg-slate-100 text-slate-800 border-slate-200";
    default:
      return "bg-slate-100 text-slate-800 border-slate-200";
  }
}

export function priorityBadgeClass(priority) {
  switch (priority) {
    case "URGENT":
    case "CRITICAL":
      return "bg-rose-100 text-rose-800 border-rose-200";
    case "HIGH":
      return "bg-orange-100 text-orange-800 border-orange-200";
    case "MEDIUM":
      return "bg-sky-100 text-sky-800 border-sky-200";
    case "LOW":
      return "bg-slate-100 text-slate-800 border-slate-200";
    default:
      return "bg-slate-100 text-slate-800 border-slate-200";
  }
}

export function roleBadgeClass(role) {
  switch (role) {
    case "SUPER_ADMIN":
      return "bg-purple-100 text-purple-800 border-purple-200";
    case "ADMIN":
      return "bg-indigo-100 text-indigo-800 border-indigo-200";
    case "PROJECT_MANAGER":
      return "bg-sky-100 text-sky-800 border-sky-200";
    case "TEAM_LEAD":
      return "bg-emerald-100 text-emerald-800 border-emerald-200";
    case "DEVELOPER":
      return "bg-amber-100 text-amber-800 border-amber-200";
    case "TESTER":
      return "bg-rose-100 text-rose-800 border-rose-200";
    case "VIEWER":
    default:
      return "bg-slate-100 text-slate-800 border-slate-200";
  }
}

export function hasPerm(user, perm) {
  if (!user || !user.permissions) return false;
  if (user.permissions.includes("*")) return true;
  return user.permissions.includes(perm);
}
